import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LoyaltyTierPill from 'loyalty/components/LoyaltyTierPill'
import TextLink from 'LuxKit/TextLink'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import TriplePointTakeoverLogo from './TriplePointTakeoverLogo'
import BodyText from 'LuxKit/Typography/BodyText'
import styled from 'styled-components'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Clickable from 'components/Common/Clickable'

const Span = styled(Clickable)`
  display: inline-grid;
  grid-template: 1ex / auto;
  place-items: center;
  vertical-align: middle;
  overflow: visible;
`

function TriplePointTakeoverSearchBanner() {
  const [tier] = useCurrentLoyaltyTier()
  const intl = useIntl()

  const triplePointsText = intl.formatMessage({
    id: '3irLpPPES2',
    defaultMessage: 'Triple Points',
    description: 'Loyalty tier pill label for triple points promotion',
  })

  const viewAllOffersText = intl.formatMessage({
    id: 'xc1/PQ86W5',
    defaultMessage: 'View all offers',
    description: 'Link text to view all triple points offers',
  })

  return <Group direction="horizontal" gap={20} verticalAlign="center">
    <CSSBreakpoint min="tablet"><TriplePointTakeoverLogo size="medium" /></CSSBreakpoint>
    <VerticalSpacer gap={2}>
      <Heading variant="heading3">
        <FormattedMessage
          id="Rwc3Q98K3o"
          defaultMessage="Your next trip just got <i>3x</i> better"
          description="Search banner heading for triple points takeover"
          values={{ i: (chunks) => <i>{chunks}</i> }}
        />
      </Heading>
      <CSSBreakpoint max="mobile">
        <Group direction="horizontal" gap={8} wrap="wrap">
          <BodyText variant="large">
            <FormattedMessage
              id="tpVxc4gzul"
              defaultMessage="Look for {pill}"
              description="Mobile text directing users to look for triple points pill on offers"
              values={{
                pill: <Span to="/triple-points"><LoyaltyTierPill kind="primary" tier={tier}>{triplePointsText}</LoyaltyTierPill></Span>,
              }}
            />{' '}
          </BodyText>
          <TextLink size="large" to="/triple-points" weight="regular">{viewAllOffersText}</TextLink>
        </Group>
      </CSSBreakpoint>
      <CSSBreakpoint min="tablet">
        <BodyText variant="large">
          <FormattedMessage
            id="0jAznhzcNu"
            defaultMessage="Look for {pill} on select packages! Hurry, limited time only."
            description="Desktop text directing users to look for triple points pill on select packages"
            values={{
              pill: <Span to="/triple-points"><LoyaltyTierPill kind="primary" tier={tier}>{triplePointsText}</LoyaltyTierPill></Span>,
            }}
          />{' '}
          <TextLink to="/triple-points">{viewAllOffersText}</TextLink>
        </BodyText>
      </CSSBreakpoint>
    </VerticalSpacer>
  </Group>
}

export default TriplePointTakeoverSearchBanner
